/**
 * **The client's unread message**, whole, as a bubble — and the way to answer it: the client's
 * conversation on `/czat`.
 *
 * The preview is the queue's own (`messagePreview`); the conversation is not read here.
 */

import type { TaskDensity } from '../lib/taskWrites';
import type { AttentionItem } from '../model/attentionItems';
import { ChatLink } from './TaskActs';
import styles from './taskBlocks.module.css';

export function MessageBlock({ item, density }: { readonly item: AttentionItem; readonly density: TaskDensity }) {
  const preview = item.triage.messagePreview;
  return (
    <div className={`${String(styles.stack)} ${String(styles[density])}`}>
      {preview === null ? null : <p className={styles.bubble}>{preview}</p>}
      {/* On the desk the bar's own „Odpisz" opens the chat panel; one way there is enough. */}
      {density === 'desk' || !item.messageable ? null : <ChatLink customerId={item.subjectCustomerId} />}
    </div>
  );
}
